import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  paper: { overflow: 'initial !important' },
  fullHeight: { overflow: 'initial !important', height: 'calc(100% - 64px)' },
}));
